import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import NewDesign from 'components/NewDesign';
import Copy from 'components/Copy';
import { isString } from 'lodash';

const propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  className: PropTypes.string,
};

const DialogShowLongContent = ({ isOpen, toggle, className, content }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={className} style={{ maxWidth: 1440 }}>
      <ModalBody>
        {isString(content) && (
          <div
            className='d-flex justify-content-between mb-2 bg-color-white p-2'
            style={{ position: 'sticky', top: 0 }}
          >
            <NewDesign.Typography component='h5'>View content</NewDesign.Typography>
            <Copy id='copy-long-text' text={isString(content) ? content : ''} />
          </div>
        )}

        <div className='default-border p-1'>{content}</div>
      </ModalBody>

      <ModalFooter>
        <NewDesign.Button variant='text' type='button' className='btn' onClick={toggle}>
          Close
        </NewDesign.Button>
      </ModalFooter>
    </Modal>
  );
};

DialogShowLongContent.propTypes = propTypes;
export default React.memo(DialogShowLongContent);
